require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-jamie-davidson.json") })
        }
      }, "path---articles-tags-jamie-davidson");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-jamie-davidson!./.cache/json/articles-tags-jamie-davidson.json
// module id = 1832
// module chunks = 231608221292675